import { tint } from "../tint";

const badge = {
  baseStyle: {
    textTransform: "none",
    fontWeight: "semibold",
  },
  variants: {
    statusSubtle: (props) => {
      const { colorScheme: c, theme } = props;
      const darkTone = theme.colors[c]?.[300];
      return {
        bg: `${c}.50`,
        color: `${c}.700`,
        borderRadius: "full",
        fontSize: "xs",
        px: 2,
        py: 0.5,
        // No escuro o fundo .50 viraria um bloco claro: tom 300 translúcido + texto 300.
        _dark: {
          bg: darkTone ? tint(darkTone, 0.16) : "whiteAlpha.200",
          color: `${c}.300`,
        },
      };
    },
  },
};

export default badge;
